import type { PoolDetailItem, PoolOverviewItem, UserPositionItem } from '~/service/modules/amm'

export const useAmm = createGlobalState(() => {
  // const { run: _getPoolList, isLoading: isLoadingList } = useHttp(vesselApi.amm.getPoolList)
  const { run: _getPoolDetailList, isLoading: isLoadingDetailList } = useHttp(vesselApi.amm.getPoolDetailList)
  const { run: _getPoolOverviewList, isLoading: isLoadingOverviewList } = useHttp(vesselApi.amm.getPoolOverviewList)
  const { run: getPosition, isLoading: isLoadingUserPosition } = useHttp(vesselApi.amm.getUserPosition)
  // const poolList = ref<PoolItem[]>([])
  const poolDetailList = ref<PoolDetailItem[]>([])
  const poolOverviewList = ref<PoolOverviewItem[]>([])
  const selectPoolRow = ref<UserPositionItem>()
  const userPoolList = ref<UserPositionItem[]>([])
  const { isSigned } = useKey()

  const selectPool = computed(() => userPoolList.value.find(i => i.poolId === selectPoolRow.value?.poolId && i.tickL === selectPoolRow.value.tickL && i.tickR === selectPoolRow.value.tickR))
  function getPoolOverviewList() {
    _getPoolOverviewList().then((res) => {
      poolOverviewList.value = res.data.pools
    })
  }
  function getPoolDetailList() {
    _getPoolDetailList().then((res) => {
      poolDetailList.value = res.data.pools
    })
  }
  function updatePool() {
    if (!poolDetailList.value.length) {
      getPoolDetailList()
    }
  }
  function updatePoolOverviewList() {
    if (!poolOverviewList.value.length) {
      getPoolOverviewList()
    }
  }

  function getUserPosition() {
    if (isSigned.value) {
      getPosition().then((res) => {
        userPoolList.value = res.data.positions
      })
    }
  }

  return {
    getPoolDetailList,
    getPoolOverviewList,
    poolDetailList,
    poolOverviewList,
    isLoadingOverviewList,
    updatePool,
    selectPool,
    selectPoolRow,
    isLoadingDetailList,
    getUserPosition,
    userPoolList,
    isLoadingUserPosition,
    updatePoolOverviewList,
  }
})
